<div style="display: flex; align-items: center">
  <div style="flex: 1">
    <app-template-number [disabled]="disabled" [characters]="characters" [value]="value" [control]="control" [required]="required" />
  </div>
  <div style="flex: 1">
    <app-prefix-bed [disabled]="true" [value]="price" />
  </div>
</div>
